var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {},
    [
      _c("navbar"),
      _vm._v(" "),
      _c("main", { staticClass: "main", attrs: { role: "main" } }, [
        _c("div", { staticClass: "py-5 bg-light" }, [
          _c(
            "div",
            { staticClass: "container" },
            [
              _c("router-link", { attrs: { to: "top" } }, [
                _vm._v(_vm._s(_vm.$t("ordertop.myhome")) + " ")
              ]),
              _vm._v("/ " + _vm._s(_vm.$t("top.myorder")) + "\n        "),
              _c("div", { staticClass: "card mt-4" }, [
                _c(
                  "div",
                  { staticClass: "card-body" },
                  [
                    _c("h5", { staticClass: "card-title" }, [
                      _vm._v(_vm._s(_vm.$t("orderList.titleList")))
                    ]),
                    _vm._v(" "),
                    _c("h6", {
                      staticClass: "card-subtitle mt-2 mb-2 text-muted"
                    }),
                    _vm._v(" "),
                    _c("p", { staticClass: "card-text" }, [
                      _vm._v(_vm._s(_vm.$t("orderList.textList")))
                    ]),
                    _vm._v(" "),
                    _c(
                      "router-link",
                      {
                        staticClass: "btn btn-facebook",
                        attrs: { to: "order-list" }
                      },
                      [_vm._v(_vm._s(_vm.$t("orderList.listbutton")))]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("copyright")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6ca0a1f4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ca0a1f4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/operator/order.vue
// module id = null
// module chunks = 